module.exports = __webpack_public_path__ + "static/media/KaTeX_Size3-Regular.a287c06f.ttf";